/**=========================================================
 * Module: flot-chart-bar.js
 * Initializes the flot chart plugin and attaches the
 * plugin to elements according to its type
 =========================================================*/

App.controller('FlotChartBarController', ['$scope', '$window','$http', '$filter', '$timeout',
                                       function($scope, $window, $http, $filter,$timeout) {
  'use strict';

  /**
   * Global object to load data for charts using ajax
   * Request the chart data from the server via post
   * Expects a response in JSON format to init the plugin
   * Usage
   *   chart = new floatChart(domSelector || domElement, 'server/chart-data.php')
   *   ...
   *   chart.requestData(options);
   *
   * @param  Chart element placeholder or selector
   * @param  Url to get the data via post. Response in JSON format
   */
  $window.FlotChartBar = function (element, url) {
    // Properties
    this.element = $(element);
    this.url = url;

    // Public method
    this.requestData = function (option, method, callback) {
      var self = this;

      // support params (option), (option, method, callback) or (option, callback)
      callback = (method && $.isFunction(method)) ? method : callback;
      method = (method && typeof method == 'string') ? method : 'GET';

      self.option = option; // save options

      $http({
          url:      self.url,
          cache:    false,
          method:   method
      }).then(function (data) {

          $.plot( self.element, data, option );

          if(callback) callback();

      }).catch(function(){
        $.error('Bad chart request.');
      });

      return this; // chain-ability

    };

    this.setData = function (option, data, callback) {

        var self = this;

        self.option = option; // save options

        $.plot( self.element, [data], option );

        if(callback) callback();

        return this; // chain-ability

      };

    // Listen to refresh events
    this.listen = function() {
      var self = this,
          chartPanel = this.element.parents('.panel').eq(0);

      // attach custom event
      chartPanel.on('panel-refresh', function(event, panel) {
        // request data and remove spinner when done
        self.requestData(self.option, function(){
          panel.removeSpinner();
        });

      });

      return this; // chain-ability
    };

  };

  $scope.init = function(){

	    	if($scope.model.result && $scope.model.result.accepted){
	            $scope.initialized = true;

	         // Donut
	            $timeout((function () {
	                var Selector = '#chart_offers';
	                $(Selector).each(function() {
	                    //var source = $(this).data('source') || $.error('Donut: No source defined.');
	                    var chart = new FlotChartBar(this),
	                        option = {
                    			series: {
                    				bars: {
                    					show: true,
                    					barWidth: 0.6,
                    					align: "center"
                    				}
                    			},
                    			xaxis: {
                    				mode: "categories",
                    				tickLength: 0
                    			}
                    		};
	                    // Send Request
	                    chart.setData(option, [
                            [
                                $filter('translate')('labels.TOTALCOST'), $scope.model.result.accepted
                            ],
                            [
                                $filter('translate')('labels.MINCOST'), $scope.model.result.min
                            ],
                            [
                                $filter('translate')('labels.AVERAGECOST'), $scope.model.result.average
                            ],
                            [
                                $filter('translate')('labels.MAXCOST'), $scope.model.result.max
                            ]
	                    ]);
	                });
	            }),500);

	    	} else {
	            if(!$scope.watchActivated){
	                $scope.watchActivated = true;
	                $scope.$watch('model.result.accepted', function(){
	                    if(!$scope.initialized){
	                        $scope.init();
	                    }
	                });
	            }
	        }
	    }

  $scope.init();


}]);
